function httpInterceptor($state, $cookies, $ngRedux, actionsFactory, notie) {
  Object.assign(this, {
    $state,
    ALLOW_LOGOUT_STATES: ['not-authenticated.activation', 'not-authenticated.login'],
    notie,
  });

  return {
    request: (config) => {
      config.headers = config.headers || {};
      const token = localStorage.getItem('jwt_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },

    requestError: config => config,

    responseError: (res) => {
      if (res.status === 401 && !this.ALLOW_LOGOUT_STATES.includes(this.$state.current.name)) {
        $ngRedux.dispatch(actionsFactory.authError(res.data));
      } else {
        this.notie.alert({
          type: 'error',
          text: `${res.status} - ${res.data.error ? res.data.error.message : res.data.message}`,
          position: 'bottom',
          time: 10,
        });
      }
      return Promise.reject(res);
    },
  };
}


export default httpInterceptor;
